import React from 'react';
import useTranslation from '../../Hooks/useTranslation';

// @ts-ignore
import styles from './SearchCaseContactNoResults.module.scss';

const SearchCaseContactNoResults: React.FC = () => {
	const { t } = useTranslation();

	return (
		<div className={styles.wrapper}>
			<div className={styles.text}>
				{t('component.searchCaseContactNoResults.text')}
			</div>
		</div>
	);
};

export default SearchCaseContactNoResults;
